import { createAsyncSelectors } from '@lib/selectors';
export const jiraSummarySelectors = createAsyncSelectors((state) => state.integrations.jira.summary.get);
export const jiraIntegrationSelectors = createAsyncSelectors((state) => state.integrations.jira.post);
export const jiraIntegrationUpdateSelectors = createAsyncSelectors((state) => state.integrations.jira.put);
export const jiraStatusSelectors = createAsyncSelectors((state) => state.integrations.jira.statuses.post);
